/* VD cards — quick add (single variant = direct; size variant = pick size) + wishlist + cart count. */
(function () {
  // ---- Grouptify guard (2026-10-08) ----
  // The theme renders colourway swatches itself (cards, PDP, cart drawer) from window.mpg.groups;
  // the app is a data source only. Its theme profile is global and changes under us (2026-10-07 it
  // started injecting its own card/PDP swatches and hiding ours), so detach its render passes here.
  // This runs before the app's DOMContentLoaded pass (this file is `defer`, the app config is inline).
  // Keep "Show options on product cards" ON in the app: that setting is what embeds mpg.groups.
  (function () {
    try {
      var mpg = window.mpg; if (!mpg) return;
      var pc = mpg.themeSetting && mpg.themeSetting.product_card;
      if (pc) { pc.card_id = '.vd-card--mpg-off'; pc.thrones = []; }   // card pass finds no cards -> no injection, no per-card API calls
      mpg.renderSwatchProdCustom = function () {};                       // official hook: PDP pass renders nothing
      window.addEventListener('load', function () {                     // belt and braces: drop anything that still slipped in
        setTimeout(function () { document.querySelectorAll('.vd-pdp__buy .mpg-swatch, .vd-card .mpg-swatch.mpg-card').forEach(function (n) { n.remove(); }); }, 3000);
      });
    } catch (e) {}
  })();
  function setCount(n) {
    document.querySelectorAll('[data-vd-cart-count]').forEach(function (el) { el.textContent = n; el.classList.toggle('is-zero', !n); });
  }
  function refreshCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { setCount(c.item_count); })
      .catch(function () {});
  }
  function add(id, btn) {
    if (!id) return;
    if (btn) { btn.classList.add('is-loading'); }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id, quantity: 1 })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (btn) { btn.classList.remove('is-loading'); }
        if (res.ok) {
          if (btn) {
            var lbl = btn.querySelector('.vd-card__qa-label');
            if (lbl) { var old = lbl.textContent; lbl.innerHTML = 'ADDED <svg class="vd-ck" width="10" height="10" viewBox="0 0 12 12" aria-hidden="true"><path d="M2 6.5 4.8 9.2 10 3.5" stroke="currentColor" stroke-width="1.8" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>'; setTimeout(function () { lbl.textContent = old; }, 1400); }
          }
          refreshCount();
          var om = btn && btn.closest('.vd-card__media.is-open');
          if (om) setTimeout(function () { closeMedia(om); }, 1200);
          document.dispatchEvent(new CustomEvent('vd:cart:added', { detail: res.d }));
        }
      })
      .catch(function () { if (btn) { btn.classList.remove('is-loading'); } });
  }

  // ---- Anti-mistouch helpers (2026-08-21): one overlay open globally; closing must be safe ----
  var openScrollY = 0;
  function closeMedia(m) {
    m.classList.remove('is-open');
    var b = m.querySelector('[data-vd-plus]');
    if (b) b.setAttribute('aria-expanded', 'false');
  }
  window.addEventListener('scroll', function () {
    var m = document.querySelector('.vd-card__media.is-open');
    if (m && Math.abs(window.pageYOffset - openScrollY) > window.innerHeight / 2) closeMedia(m);
  }, { passive: true });

  // Hydrate the card's hover-swap image on first pointerover. It only ever shows on :hover,
  // so shipping it deferred (data-vd-src2) means touch devices — which can't hover — never
  // download it at all, and desktops fetch it just-in-time.
  document.addEventListener('pointerover', function (e) {
    var card = e.target.closest ? e.target.closest('[data-vd-card]') : null;
    if (!card) return;
    var im2 = card.querySelector('.vd-card__img2[data-vd-src2]');
    if (im2) { im2.src = im2.getAttribute('data-vd-src2'); im2.removeAttribute('data-vd-src2'); }
  }, { passive: true });

  document.addEventListener('click', function (e) {
    var swEl = e.target.closest('.vd-card__sw');
    if (swEl) {
      var swCard = swEl.closest('[data-vd-card]');
      var swHandle = (swEl.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
      if (swCard && swHandle) { e.preventDefault(); swapCard(swCard, swHandle[1]); return; }
    }

    var nBtn = e.target.closest('[data-vd-notify]');
    if (nBtn) {                             // sold-out card: NOTIFY ME -> PDP (back-in-stock lives there)
      e.preventDefault();
      var nCard = nBtn.closest('[data-vd-card]');
      var nLink = nCard && nCard.querySelector('.vd-card__imglink');
      if (nLink && nLink.href) window.location = nLink.href;
      return;
    }

    var addBtn = e.target.closest('[data-vd-add]');
    if (addBtn) { e.preventDefault(); add(addBtn.getAttribute('data-vd-add'), addBtn); return; }

    var plusBtn = e.target.closest('[data-vd-plus]');
    if (plusBtn) {
      e.preventDefault();
      var media = plusBtn.closest('.vd-card__media');
      if (media) {
        document.querySelectorAll('.vd-card__media.is-open').forEach(function (o) { if (o !== media) closeMedia(o); });
        media.classList.toggle('is-open');
        if (media.classList.contains('is-open')) openScrollY = window.pageYOffset;
        plusBtn.setAttribute('aria-expanded', media.classList.contains('is-open') ? 'true' : 'false');
      }
      return;
    }

    var wish = e.target.closest('[data-vd-wish]');
    if (wish) {
      e.preventDefault();
      // Store product HANDLES (renderable on the wishlist page). Fall back to the card's handle.
      var handle = wish.getAttribute('data-vd-wish-handle');
      if (!handle) { var wcard = wish.closest('[data-vd-card]'); handle = wcard && wcard.getAttribute('data-vd-handle'); }
      if (!handle) return;
      var on = !wish.classList.contains('is-active');
      wish.classList.toggle('is-active', on);
      wish.setAttribute('aria-pressed', on ? 'true' : 'false');
      try {
        var list = JSON.parse(localStorage.getItem('vd_wishlist') || '[]');
        var i = list.indexOf(handle);
        if (i >= 0) { list.splice(i, 1); } else { list.push(handle); }
        localStorage.setItem('vd_wishlist', JSON.stringify(list));
      } catch (err) {}
      // keep every other heart for this product (and the wishlist page) in sync
      document.querySelectorAll('[data-vd-wish-handle="' + handle + '"]').forEach(function (b) {
        b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      document.dispatchEvent(new CustomEvent('vd:wishlist:changed', { detail: { handle: handle, added: on } }));
      return;
    }

    // While a quick-add overlay is open, a click anywhere outside it only CLOSES it.
    // Inside a card the closing click must not fall through to the PDP link.
    var openM = document.querySelector('.vd-card__media.is-open');
    if (openM && !openM.contains(e.target)) {
      closeMedia(openM);
      if (e.target.closest('[data-vd-card]')) { e.preventDefault(); e.stopPropagation(); }
    }
  });

  // ---- Client-side swatches for products without a server-rendered (Globo) swatch row ----
  // Reads window.mpg (g-combined-listings app) colorway groups; fetches each colorway's image.
  var imgCache = {};
  function getImg(handle) {
    if (imgCache[handle] !== undefined) return Promise.resolve(imgCache[handle]);
    return fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var u = d.featured_image || (d.images && d.images[0]) || '';
        if (u && u.indexOf('//') === 0) u = 'https:' + u;
        if (u) u += (u.indexOf('?') > -1 ? '&' : '?') + 'width=80';
        imgCache[handle] = u; return u;
      })
      .catch(function () { imgCache[handle] = ''; return ''; });
  }
  // Snapshot is only consulted after a short grace period, so live window.mpg.groups
  // (fresh Grouptify data, present on collection/home/page/search) always wins there and the
  // snapshot only kicks in where mpg never loads (PDP / cart).
  var snapshotOK = false;
  function findGroup(handle) {
    var gs = (window.mpg && window.mpg.groups) || [];
    for (var i = 0; i < gs.length; i++) {
      var ps = gs[i].products || [];
      for (var j = 0; j < ps.length; j++) { if (ps[j].handle === handle) return gs[i]; }
    }
    if (snapshotOK || gs.length) { // fallback: local Grouptify snapshot. Engage it once live mpg is
      // loaded (gs.length) so products live-mpg is MISSING (e.g. a group only in the snapshot) still get
      // swatches immediately — mpg is still checked first above, so it wins where it has the group.
      var fb = window.__VD_COLOR_GROUPS || [];
      for (var k = 0; k < fb.length; k++) {
        if (fb[k].indexOf(handle) > -1) { return { products: fb[k].map(function (h) { return { handle: h }; }) }; }
      }
    }
    return null;
  }
  function slotHandles(handle) {
    var group = findGroup(handle);
    if (!group) return [];
    var raw = (group.products || []).map(function (p) { return p.handle; }).filter(Boolean);
    var uniq = raw.filter(function (h, i) { return raw.indexOf(h) === i; }); // dedupe
    var ordered = [handle].concat(uniq.filter(function (h) { return h !== handle; })); // current colour first
    return ordered.length < 2 ? [] : ordered;
  }
  // Resolve a card's swatch STATE synchronously — no scroll/IO needed. The colourway groups are all
  // in memory (window.mpg / snapshot), so we can flag every card immediately: products with no
  // colourway siblings get .vd-card--no-swatch (image enlarges, see vd-card.css) page-wide at once.
  // Only the swatch-dot IMAGES stay lazy (fillSlot via IO). Fixes no-swatch cards that never entered
  // the IO viewport and so silently kept the square image.
  function resolveSlot(slot) {
    if (slot.dataset.resolved) return;
    slot.dataset.resolved = '1';
    var card = slot.closest('[data-vd-card]');
    var ordered = slotHandles(slot.getAttribute('data-product-handle'));
    if (ordered.length < 2) {               // no colourway siblings -> empty swatch track
      slot.dataset.filled = '1';
      if (card) {
        card.classList.add('vd-card--no-swatch');
        // Fill the blank track with the low-stock tag when the product has one (spec decision:
        // borderless blank + Only-N-left relocation). Has-swatch cards keep it on the media.
        var ls = card.querySelector('[data-vd-lowstock]');
        var body = card.querySelector('.vd-card__body');
        if (ls && body) { ls.classList.add('vd-card__lowstock--track'); body.appendChild(ls); }
      }
      return;
    }
    if (card) card.classList.add('vd-card--has-swatch');
    if (io) io.observe(slot); else fillSlot(slot);   // dots (+ their images) fill lazily near viewport
  }
  function swCap(slot, total) {             // how many dots fit the fixed one-line track (+N when over)
    var w = slot.clientWidth;
    if (!w) return { show: Math.min(total, 5), more: Math.max(0, total - 5) }; // unmeasurable: legacy cap
    var cs = getComputedStyle(slot);
    var cur = parseFloat(cs.getPropertyValue('--sw-cur')) || 30;
    var d = parseFloat(cs.getPropertyValue('--sw-d')) || 26;
    var g = parseFloat(cs.getPropertyValue('--sw-g')) || 6;
    w -= 4;                                 // slot padding (ring room)
    var others = total - 1;
    if (cur + others * (d + g) <= w) return { show: total, more: 0 };
    var k = Math.floor((w - cur - 26) / (d + g)); // 26px reserved for the +N counter
    if (k < 0) k = 0;
    return { show: 1 + k, more: others - k };
  }
  function renderSlot(slot) {               // (re)render dots at the current capacity
    var card = slot.closest('[data-vd-card]');
    var handle = (card && card.getAttribute('data-vd-handle')) || slot.getAttribute('data-product-handle');
    var ordered = slotHandles(handle);
    if (ordered.length < 2) return;
    var cap = swCap(slot, ordered.length);
    if (slot.dataset.shown === String(cap.show)) return;   // capacity unchanged: keep DOM (and images)
    slot.dataset.shown = String(cap.show);
    // The Notify Me! SDK parks its hidden trigger portal inside this slot on sold-out
    // cards — keep it across re-renders (column switches) or same-page notify breaks.
    var portals = [].slice.call(slot.querySelectorAll('.nm-portal'));
    slot.textContent = '';
    portals.forEach(function (pt) { slot.appendChild(pt); });
    ordered.slice(0, cap.show).forEach(function (h) {
      var a = document.createElement('a');
      a.className = 'vd-card__sw' + (h === handle ? ' is-current' : '');
      a.href = '/products/' + h;
      a.setAttribute('aria-label', h.split('-').join(' ')); // accessible link name — handle reads as the colourway name
      slot.appendChild(a);
      // getProduct hits the same /products/{h}.js endpoint as getImg (no extra request) but also
      // exposes `available` -> grey out a colourway whose product is entirely sold out (still clickable).
      getProduct(h).then(function (p) {
        if (!p) return;
        var u = imgUrl(p.featured_image || (p.images && p.images[0]) || '', 80);
        if (u) a.style.backgroundImage = "url('" + u + "')";
        if (p.available === false) a.classList.add('vd-card__sw--soldout');
      });
    });
    if (cap.more > 0) {
      var s = document.createElement('span');
      s.className = 'vd-card__sw-more';
      s.textContent = '+' + cap.more;
      slot.appendChild(s);
    }
  }
  // ---- Width tiers (2026-08-21): replaces @container queries. container-type:inline-size on
  // .vd-card disables grid-template-rows:subgrid on the same element (Chrome), so the card
  // cannot be its own query container. A ResizeObserver stamps data-vd-tier instead. ----
  function tierOf(w) { return w < 200 ? 'xs' : w < 260 ? 's' : w < 300 ? 'm' : 'l'; }
  // Writes happen on the NEXT frame: mutating the observed card inside the callback changes its
  // own size in the same layout pass, which browsers report as "ResizeObserver loop completed
  // with undelivered notifications" (Clarity's #2 JS error, 2026-10-02). Deferring one frame
  // breaks the loop; the initial stamp in observeTiers() is still synchronous.
  var tierRO = ('ResizeObserver' in window)
    ? new ResizeObserver(function (ents) {
        var targets = ents.map(function (en) { return en.target; });
        requestAnimationFrame(function () {
          targets.forEach(function (el) {
            var t = tierOf(el.clientWidth || 0);
            if (el.getAttribute('data-vd-tier') !== t) el.setAttribute('data-vd-tier', t);
          });
        });
      })
    : null;
  function observeTiers() {
    document.querySelectorAll('[data-vd-card]:not([data-vd-tier])').forEach(function (c) {
      c.setAttribute('data-vd-tier', tierOf(c.clientWidth || 0));
      if (tierRO) tierRO.observe(c);
    });
  }
  observeTiers();
  window.vdObserveTiers = observeTiers;

  var swRO = ('ResizeObserver' in window)
    ? new ResizeObserver(function (ents) {   // same one-frame deferral as tierRO (see above)
        var targets = ents.map(function (en) { return en.target; });
        requestAnimationFrame(function () { targets.forEach(renderSlot); });
      })
    : null;                                  // column switch / rotation refits every row
  function fillSlot(slot) {                 // lazy: render the swatch dots and fetch their images
    if (slot.dataset.filled) return;
    var ordered = slotHandles(slot.getAttribute('data-product-handle'));
    if (ordered.length < 2) { slot.dataset.filled = '1'; return; }
    slot.dataset.filled = '1';
    renderSlot(slot);
    if (swRO) swRO.observe(slot);
  }
  // ---- PDP apparel swatches: fill [data-pdp-swatches] from window.mpg (current already rendered) ----
  function fillPdpSwatches(slot) {
    if (slot.dataset.filled) return;
    var handle = slot.getAttribute('data-handle');
    var group = findGroup(handle);
    if (!group) return;
    var raw = (group.products || []).map(function (p) { return p.handle; }).filter(Boolean);
    var sibs = raw.filter(function (h, i) { return raw.indexOf(h) === i && h !== handle; }); // dedupe + exclude current
    if (!sibs.length) return;
    slot.dataset.filled = '1';
    sibs.forEach(function (h) {
      var a = document.createElement('a');
      a.className = 'vd-pdp__swatch'; a.href = '/products/' + h; a.setAttribute('title', h);
      a.setAttribute('aria-label', h.split('-').join(' ')); // a11y: accessible name before the product fetch lands
      var im = document.createElement('img'); im.alt = ''; im.loading = 'lazy';
      a.appendChild(im); slot.appendChild(a);
      getProduct(h).then(function (p) { // full product → proper tooltip title + 200px swatch (crisp on retina)
        if (!p) return;
        if (p.title) a.setAttribute('title', p.title);
        var u = p.featured_image || (p.images && p.images[0]) || '';
        if (u) { if (u.indexOf('//') === 0) u = 'https:' + u; im.src = u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=200'; }
        if (p.available === false) a.classList.add('vd-pdp__swatch--soldout'); // grey out a fully sold-out colourway
        // a11y: real title + programmatic sold-out state (audit item 1 companion)
        a.setAttribute('aria-label', (p.title || h.split('-').join(' ')) + (p.available === false ? ' — sold out' : ''));
      });
    });
  }

  // ---- In-place colour swap: click a swatch → card becomes that colourway ----
  var prodCache = {};
  function getProduct(h) {
    if (prodCache[h]) return Promise.resolve(prodCache[h]);
    return fetch('/products/' + h + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) { prodCache[h] = p; return p; })
      .catch(function () { return null; });
  }
  function imgUrl(u, w) { if (!u) return ''; if (u.indexOf('//') === 0) u = 'https:' + u; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function money(c) { var d = c / 100; return '$' + (d % 1 === 0 ? d : d.toFixed(2)); }
  function handleFromHref(a) { var m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/); return m ? m[1] : ''; }

  function swapCard(card, handle) {
    getProduct(handle).then(function (p) {
      if (!p) return;
      var url = '/products/' + p.handle;
      var price = p.price, compare = p.compare_at_price || 0;
      var save = (compare > price) ? compare - price : 0;
      var disc = save > 0 ? Math.round(save * 100 / compare) : 0;
      var tags = (p.tags || []).map(function (t) { return ('' + t).toLowerCase(); });

      var img = card.querySelector('.vd-card__img');
      if (img) { img.removeAttribute('srcset'); img.src = imgUrl(p.featured_image, 600); }
      var img2 = card.querySelector('.vd-card__img2');
      if (img2) { img2.removeAttribute('data-vd-src2'); if (p.images && p.images[1]) { img2.src = imgUrl(p.images[1], 600); img2.style.display = ''; } else { img2.style.display = 'none'; } }

      var titleEl = card.querySelector('.vd-card__title');
      if (titleEl) { titleEl.textContent = (p.title || '').replace(/^\s*\(PRE-?ORDER\)\s*/i, ''); titleEl.href = url; }
      var link = card.querySelector('.vd-card__imglink'); if (link) link.href = url;
      var wish = card.querySelector('.vd-card__wish');
      if (wish) {
        wish.setAttribute('data-vd-wish', p.id);
        wish.setAttribute('data-vd-wish-handle', p.handle);
        wish.setAttribute('aria-label', 'Add ' + (p.title || '') + ' to wishlist');   // a11y: label follows the colourway swap
        try {
          var wl = JSON.parse(localStorage.getItem('vd_wishlist') || '[]');
          var wOn = wl.indexOf(p.handle) >= 0;
          wish.classList.toggle('is-active', wOn); wish.setAttribute('aria-pressed', wOn ? 'true' : 'false');
        } catch (e) {}
      }

      card.classList.toggle('is-soldout', !p.available); // reveal/hide quick-add overlay for the new colour
      var nowEl = card.querySelector('.vd-card__now'); if (nowEl) nowEl.textContent = money(price);
      var priceRow = card.querySelector('.vd-card__price');
      if (priceRow) {
        priceRow.querySelectorAll('.vd-card__compare,.vd-card__save,.vd-card__soldtag').forEach(function (e) { e.remove(); });
        if (compare > price && nowEl) {
          var c = document.createElement('s'); c.className = 'vd-card__compare'; c.textContent = money(compare);
          nowEl.insertAdjacentElement('afterend', c);
        }
        if (!p.available) {
          var so = document.createElement('span'); so.className = 'vd-card__soldtag'; so.setAttribute('data-vd-soldcard', '1'); so.textContent = 'SOLD OUT'; priceRow.appendChild(so);
        } else if (save > 0) {
          var sv = document.createElement('span'); sv.className = 'vd-card__save'; sv.textContent = 'SAVE ' + money(save); priceRow.appendChild(sv);
        }
      }

      // badges
      var media = card.querySelector('.vd-card__media');
      var badges = card.querySelector('.vd-card__badges');
      // same rule as vd-product-card.liquid: PRE-ORDER > %OFF > NEW > BEST SELLER, max 2
      var isPre = tags.indexOf('preorder') > -1 || /\(PRE-?ORDER\)/i.test(p.title || '');
      var bl = [];
      if (isPre) bl.push('<span class="vd-card__badge vd-card__badge--outline">PRE-ORDER</span>');
      if (disc > 0) bl.push('<span class="vd-card__badge vd-card__badge--sale">' + disc + '% OFF</span>');
      if (tags.indexOf('new') > -1) bl.push('<span class="vd-card__badge vd-card__badge--outline">NEW</span>');
      if (tags.indexOf('best seller') > -1 || tags.indexOf('bestseller') > -1) bl.push('<span class="vd-card__badge vd-card__badge--outline">BEST SELLER</span>');
      var bh = bl.slice(0, 2).join('');
      if (badges) { if (bh) badges.innerHTML = bh; else badges.remove(); }
      else if (bh && media) { var nb = document.createElement('div'); nb.className = 'vd-card__badges'; nb.innerHTML = bh; media.insertBefore(nb, media.firstChild); }

      // quick add — a11y: rebuilt buttons carry the new colourway's title in their labels
      var tAttr = ('' + (p.title || '')).replace(/"/g, '&quot;');
      var single = (p.variants || []).length <= 1;
      var addBtn = card.querySelector('.vd-card__add[data-vd-add]');
      if (single && addBtn) { addBtn.setAttribute('data-vd-add', p.variants[0].id); addBtn.setAttribute('aria-label', 'Add ' + (p.title || '') + ' to bag'); }
      var plus = card.querySelector('.vd-card__plus');
      if (plus) plus.setAttribute('aria-label', 'Quick add — ' + (p.title || ''));
      var sizesWrap = card.querySelector('.vd-card__sizes');
      if (!single && sizesWrap) {
        sizesWrap.innerHTML = p.variants.map(function (v) {
          var vAttr = ('' + (v.title || '')).replace(/"/g, '&quot;');
          return v.available
            ? '<button class="vd-card__size" type="button" data-vd-add="' + v.id + '" aria-label="Add ' + tAttr + ' — size ' + vAttr + ' to bag">' + (v.title || '') + '</button>'
            : '<button class="vd-card__size is-soldout" type="button" data-vd-soldsize="' + v.id + '" aria-label="' + tAttr + ' size ' + vAttr + ' sold out — notify me when back">' + (v.title || '') + '</button>';
        }).join('');
      }

      // swatches: mark clicked current + move first
      var slot = card.querySelector('.vd-card__swatches');
      if (slot) {
        var dots = [].slice.call(slot.querySelectorAll('.vd-card__sw'));
        dots.forEach(function (d) { d.classList.toggle('is-current', handleFromHref(d) === handle); });
        var clicked = dots.filter(function (d) { return handleFromHref(d) === handle; })[0];
        if (clicked) slot.insertBefore(clicked, slot.firstChild);
      }
      card.setAttribute('data-vd-handle', handle);
    });
  }

  var io = ('IntersectionObserver' in window)
    ? new IntersectionObserver(function (ents) {
        ents.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); fillSlot(e.target); } });
      }, { rootMargin: '300px' })
    : null;
  function initSwatches() {
    var live = window.mpg && window.mpg.groups && window.mpg.groups.length;
    var snap = snapshotOK && window.__VD_COLOR_GROUPS && window.__VD_COLOR_GROUPS.length;
    if (!live && !snap) return false;
    observeTiers();                       // AJAX-appended cards (load-more / chips) get their tier here
    document.querySelectorAll('[data-vd-swatch-slot]:not([data-resolved])').forEach(resolveSlot);
    // PDP swatches (current already server-rendered; siblings from window.mpg or the local snapshot)
    document.querySelectorAll('[data-pdp-swatches]:not([data-filled])').forEach(fillPdpSwatches);
    return true;
  }
  (function pollMpg() {
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      if (tries > 3) snapshotOK = true; // ~1s grace for live window.mpg before the snapshot fallback engages
      if (initSwatches() || tries > 40) clearInterval(iv);
    }, 350);
  })();
  // expose for AJAX-appended cards (Discover load-more / filter)
  window.vdInitSwatches = initSwatches;

  // restore wishlist hearts (keyed by product handle)
  function restoreWishlistHearts() {
    try {
      var saved = JSON.parse(localStorage.getItem('vd_wishlist') || '[]');
      document.querySelectorAll('[data-vd-wish-handle]').forEach(function (el) {
        var on = saved.indexOf(el.getAttribute('data-vd-wish-handle')) >= 0;
        el.classList.toggle('is-active', on);
        el.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    } catch (e) {}
  }
  restoreWishlistHearts();
  // re-apply to AJAX-appended cards (Discover load-more, wishlist page render, etc.)
  window.vdRestoreWishlist = restoreWishlistHearts;
  document.addEventListener('vd:wishlist:changed', restoreWishlistHearts);
})();
